import { useEffect, useState } from "react";

import ProgressSteps from "../../utils/ProgressSteps";

import SciensHaloLogo from "../../utils/SciensHaloLogo.svg";
import backIcon from "../../utils/backIcon.png";
import { useNavigate } from "react-router-dom";
import OnboardingStep1 from "./OnboardingStep1";
import OnboardingStep2 from "./OnboardingStep2";
import OnboardingStep3 from "./OnboardingStep3";
import apiCall from "../../network/api";
import OnboardingStep4 from "./OnboardingStep4";
import SuccessRejectionScreen from "../SuccessRejectionScreen";
import { loader } from "../../utils/svg";
import { ONBOARDING_STATUS } from "../../utils/constants";
import { getFormattedDateTime } from "../../utils/genericFunctions";

const ObcOnboardingSteps = () => {
  const rejectionMessageAndDetails = [
    {
      reason: "notOlderThan18",
      message:
        "We require all applicants to be at least 18 years old to proceed with the application.",
      details: "Wait until you turn 18 and apply again.",
    },
    {
      reason: "notFluentInEnglish",
      message:
        "We require all applicants to be able to communicate fluently in English.",
      details:
        "We value your interest, and once you've had the opportunity to strengthen your English proficiency, we would be happy to review your application again.",
    },
    {
      reason: "noSmartphoneRoaming",
      message:
        "As our AOG situations will pan across multiple countries, it is important for all our applicants to have an international roaming enabled/capable smartphone.",

      details:
        "For this role, we require all team members to have a smartphone with international roaming capabilities. Once you have arranged for a suitable mobile plan with international roaming, please feel free to submit your application again.",
    },
    {
      reason: "noValidPassport",
      message:
        "Your application requires a passport with at least 6 months validity. We invite you to reapply once you have renewed your passport to meet this requirement.",
      details:
        "Consider submitting a new application after updating your passport's validity through either renewal or extension. We look forward to reviewing your application once this requirement is met.",
    },
  ];
  const [step, setStep] = useState(1);
  const [status, setStatus] = useState("");
  const [rejectionMessage, setRejectionMessage] = useState("");
  const [rejectionDetails, setRejectionDetails] = useState([]);
  const [rejectionLoader, setRejectionLoader] = useState(false);
  const [loading, setLoading] = useState(true);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    country: "US",
    countryCode: "+1",
    nationality: "American",
  });

  const [formDataStep2, setFormDataStep2] = useState({
    notOlderThan18: "",
    notFluentInEnglish: "",
    noSmartphoneRoaming: "",
    noValidPassport: "",
  });

  const [formDataStep3, setFormDataStep3] = useState({
    country: "United States",
    airport: "",
    flights: "",
    passportNumber: "",
  });

  const navigate = useNavigate();
  // const { email, row } = location.state ?? {};

  const emailId = localStorage.getItem("onboardingUserEmail");

  const [rowData, setRowData] = useState();

  // fetch row data and columns
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await apiCall({
          endpoint: "/otp/get-signup-row",
          method: "GET",
          params: {
            email: emailId,
          },
        });
        setRowData(result.data);
      } catch (err) {
      } finally {
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step, status]);

  const [countryOptions, setCountryOptions] = useState([]);
  //fetch country options
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await apiCall({
          endpoint: "/list-country-details",
          method: "GET",
          data: null,
        });
        setCountryOptions(result.data);
      } catch (err) {
      } finally {
      }
    };
    fetchData();
  }, []);

  //set submitted / status screen
  useEffect(() => {
    if (rowData !== undefined)
      if (rowData?.onboardingStatus?.status === ONBOARDING_STATUS.ACCEPTED) {
        navigate("/login");
      } else if (
        rowData?.onboardingStatus?.status === ONBOARDING_STATUS.IN_REVIEW
      ) {
        setLoading(false);
        setStatus("submitted");
        navigate("/onboarding/submitted");
      } else if (
        [
          ONBOARDING_STATUS.PARTIAL_REJECTED,
          ONBOARDING_STATUS.SYSTEM_REJECTED,
          ONBOARDING_STATUS.REJECTED,
        ].includes(rowData?.onboardingStatus?.status)
      ) {
        setLoading(false);
        setStatus("rejected");
        setRejectionLoader(true);
        navigate("/onboarding/rejected");

        let message = [];
        let details = [];
        let userMessage = rowData?.onboardingStatus?.reason;

        rejectionMessageAndDetails?.forEach((obj) => {
          if (userMessage.includes(obj?.reason)) {
            message.push(obj?.message);
            details?.push(obj?.details);
            userMessage = userMessage?.replace(`${obj?.reason},`, "");
            userMessage = userMessage?.replace(obj?.reason, "");
          }
        });
        setRejectionMessage([...message, userMessage]);
        setRejectionDetails([...details]);
        setRejectionLoader(false);
      } else {
        setLoading(false);
        setStatus("onboarding");
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowData]);

  const next = (step) => {
    if (step < 4) {
      const NewStep = step + 1;
      setStep(NewStep);
      navigate(`step${NewStep}`);
    } else {
      setStatus("submitted");
      navigate("/onboarding/submitted");
    }
  };
  const back = (step) => {
    const NewStep = step - 1;
    setStep(NewStep);
    navigate(`step${NewStep}`);
  };

  const [verificationLoader, setVerificationLoader] = useState(false);

  const handleRowUpdate = async ({ updateData }) => {
    setVerificationLoader(true);
    try {
      await apiCall({
        endpoint: "/otp/update-signup-onboarding",
        method: "PUT",
        data: {
          emailId: emailId,
          updateData: updateData,
          emailData: {
            customerName: emailId.trim().split("@")[0],
            // status: "email_verification",
            emailTo: emailId,
            emailBcc: "",
          },
        },
      });

      next(step);
    } catch (err) {
      console.log(err?.data?.message);
    } finally {
      setVerificationLoader(false);
    }
  };

  return (
    <div className="min-h-screen bg-white p-8 flex flex-col justify-between">
      {loading ? (
        <div className="max-w-lg mx-auto w-full flex justify-center items-center">
          {loader()}
        </div>
      ) : (
        <div
          className={
            status !== "rejected"
              ? "max-w-lg mx-auto"
              : "max-w-lg mx-auto w-full"
          }
        >
          <div className="mb-3 flex">
            {step > 1 && status === "onboarding" ? (
              <div className="mt-2 mr-4 cursor-pointer">
                <img
                  onClick={() => back(step)}
                  style={{ width: "1.6rem", height: "auto" }}
                  src={backIcon}
                  alt="back"
                />
              </div>
            ) : (
              ""
            )}
            <div className="mb-3">
              <img
                src={SciensHaloLogo}
                alt="SciensLogistics Halo Logo"
                className="h-14"
              />
            </div>
          </div>

          {status === "onboarding" ? (
            <div className="w-lg mx-auto bg-white">
              <ProgressSteps
                currentStep={step}
                totalSteps={4}
                header={"Application Form"}
              />

              <div className="w-[20rem] md:w-[22rem] lg:w-[24rem]">
                {step === 1 && (
                  <OnboardingStep1
                    back={back}
                    next={next}
                    step={step}
                    countryOptions={countryOptions}
                    handleRowUpdate={handleRowUpdate}
                    verificationLoader={verificationLoader}
                    rowData={rowData}
                    formData={formData}
                    setFormData={setFormData}
                  />
                )}
                {step === 2 && (
                  <OnboardingStep2
                    back={back}
                    next={next}
                    step={step}
                    handleRowUpdate={handleRowUpdate}
                    verificationLoader={verificationLoader}
                    rowData={rowData}
                    setStatus={setStatus}
                    formDataStep2={formDataStep2}
                    setFormDataStep2={setFormDataStep2}
                  />
                )}
                {step === 3 && (
                  <OnboardingStep3
                    back={back}
                    next={next}
                    step={step}
                    countryOptions={countryOptions}
                    handleRowUpdate={handleRowUpdate}
                    verificationLoader={verificationLoader}
                    rowData={rowData}
                    formDataStep3={formDataStep3}
                    setFormDataStep3={setFormDataStep3}
                  />
                )}
                {step === 4 && (
                  <OnboardingStep4
                    back={back}
                    next={next}
                    step={step}
                    handleRowUpdate={handleRowUpdate}
                    verificationLoader={verificationLoader}
                    rowData={rowData}
                    setVerificationLoader={setVerificationLoader}
                  />
                )}
              </div>
            </div>
          ) : status === "submitted" ? (
            <div className="w-lg mx-auto bg-white">
              <SuccessRejectionScreen
                isSuccess={true}
                heading={"Application Submitted"}
                message={"Your application has been successfully submitted"}
                successDetails={[
                  `Submitted on: ${getFormattedDateTime(rowData?.onboardingStatusTime)}`,
                ]}
                successMessage={
                  "We'll review your application and get back to you within 24-48 hours"
                }
                buttonAction={() => navigate("/")}
              />
            </div>
          ) : status === "rejected" ? (
            <div className="w-lg mx-auto bg-white">
              <SuccessRejectionScreen
                isSuccess={false}
                isRejected={true}
                heading={"Application Rejected"}
                message={
                  "Unfortunately, you do not meet the eligibility criteria."
                }
                rejectionDetails={[
                  ...rejectionDetails,
                  "Contact our support team if you think this is a mistake.",
                ]}
                rejectionReason={rejectionMessage}
                buttonAction={() => navigate("/")}
                rejectionLoader={rejectionLoader}
              />
            </div>
          ) : (
            <div></div>
          )}
        </div>
      )}
    </div>
  );
};

export default ObcOnboardingSteps;
